/** experiment ids go here */
export const EXP_035_SUB_PRICE = 'exp_035_sub_price';
